import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { WithTheme } from '../../../setup/index'
import media from '../../../common/MediaQueries'
import { transition } from './../../../common/Mixins'

const WysiwygStyled = styled.div<WithTheme>`
  width: 100%;

  *:not([class]) {
    font-size: 0.875rem;
    line-height: 1.6;
    color: ${({ theme }) => theme.colors.black};
    word-break: break-word;
    font-weight: ${({ theme }) => theme.fontWeights.regular};
    &:not(:last-child) {
      margin-bottom: 0.625rem;
    }
    br:not([class]) {
      margin-bottom: 0;
    }
  }

  img {
    display: block;
    margin: 1rem 0;
    height: auto;
    max-width: 100%;
    border-radius: 0.3125rem;
  }

  a:not([class]) {
    ${transition};
    line-height: 1;
    transition: background-size 0.3s;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.green};
    &:hover {
      opacity: 0.8;
    }
  }

  h1:not([class]),
  h2:not([class]),
  h3:not([class]) {
    color: ${({ theme }) => theme.colors.black};
  }

  h4:not([class]) {
    color: ${({ theme }) => theme.colors.black};
  }

  h5:not([class]),
  h6:not([class]) {
    color: ${({ theme }) => theme.colors.black};
  }

  h1:not([class]),
  h2:not([class]),
  h3:not([class]),
  h4:not([class]),
  h5:not([class]),
  h6:not([class]) {
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    line-height: 1.2;

    * {
      font-size: inherit;
      font-weight: ${({ theme }) => theme.fontWeights.semibold};
    }
  }

  h1:not([class]),
  h1:not([class]) * {
    font-size: 2rem;
    @media ${media.phone} {
      font-size: 3.375rem;
    }
  }
  h2:not([class]),
  h2:not([class]) * {
    font-size: 1.25rem;
    @media ${media.phone} {
      font-size: 1.875rem;
    }
  }
  h3:not([class]),
  h3:not([class]) * {
    font-size: 1.125rem;
    @media ${media.phone} {
      font-size: 1.5rem;
    }
  }
  h4:not([class]),
  h4:not([class]) *,
  h5:not([class]),
  h5:not([class]) *,
  h6:not([class]),
  h6:not([class]) * {
    font-size: 1.125rem;
    @media ${media.phone} {
      font-size: 1.25rem;
    }
  }

  ol {
    list-style: decimal;
  }

  ul,
  ol {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-right: 2rem;' : 'margin-left: 2rem;')}
  }

  ul {
    list-style: none;
    padding: 0;
  }

  ul li,
  ol li {
    text-indent: -0.7em;
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 1em;' : 'padding-left: 1em;')}
  }

  ul li {
    &::before {
      content: '•';
      position: relative;
      color: ${({ theme }) => theme.colors.green};
      font-size: 1.375rem;
      line-height: 1;
      ${({ theme }) => (theme.direction === 'rtl' ? 'left: 0.5rem;' : 'right: 0.5rem;')}
    }
  }

  strong:not([class]) {
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }

  em:not([class]) {
    font-style: italic;
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }

  table:not([class]) {
    border-collapse: collapse;

    @media ${media.maxPhone} {
      display: block;
      overflow-x: auto;
      white-space: nowrap;
    }
    @media ${media.phone} {
      border: 0.0625rem solid ${({ theme }) => theme.colors.black};
    }
  }

  table:not([class]) thead th {
    background-color: ${({ theme }) => theme.colors.green};
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    border-collapse: collapse;
    display: table-cell;
    vertical-align: middle;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    padding: 0.625rem;
    border: 0.0625rem solid ${({ theme }) => theme.colors.black};

    > * {
      margin: 0;
      word-break: normal;
      font-size: 0.875rem;
    }
  }

  table:not([class]) tbody td {
    border: 0.0625rem solid ${({ theme }) => theme.colors.black};
    border-collapse: collapse;
    display: table-cell;
    vertical-align: middle;
    padding: 0.625rem;
    font-size: 0.75rem;
    word-break: normal;

    @media ${media.maxPhone} {
      white-space: break-spaces;
      max-width: 18.75rem;
    }

    @media ${media.phone} {
      font-size: 0.875rem;
    }
    > * {
      margin: 0;
    }
  }

  .has-text-align-center {
    text-align: center;
  }

  .wp-block-quote {
    text-align: center;
    padding: 0.5rem 0;
    em:not([class]) {
      display: block;
    }
  }

  @media ${media.phone} {
    .alignright {
      float: right;
      margin-left: 1rem;
    }

    .alignleft {
      float: left;
      margin-right: 1rem;
    }
  }
`

export { WysiwygStyled }
